<div [hidden]="!allApprovers || allApprovers.length == 0">
	<h5 [hidden]="hideHeading">Approvers</h5>
	<div class="card">
		<div class="card-body table-responsive">
			<table class="table table-bordered">
				<thead>
					<th>Name</th>
					<th>Approved By</th>
					<th>Workflow Step</th>
					<th *ngIf="!hideCurrentApproveColumn">Is Current Approver?</th>
					<th>Substitute For</th>
					<th>Approved Date</th>
				</thead>
				<tbody>
					<tr *ngFor="let approver of allApprovers">
						<td>
							<span *ngIf="approver.groupName"
								><strong>Group: </strong> <u>{{ approver.groupName }}</u> <br />
							</span>
							<span *ngIf="approver.isLocationManager"><strong>Location Manager</strong> <br /> </span>
							<ng-container *ngIf="isRuleBasedGroup(approver)">
								<ng-container *ngIf="getMatchedRuleInfo(approver) as matchedRuleInfo">
									<span>
										<strong>Rule-Based Approval</strong><br />
										<div
											style="margin-left: 20px; margin-top: 8px; margin-bottom: 8px; font-size: 12px; color: #525f7f"
										>
											<strong>Matched Rule:</strong><br />
											<div
												*ngFor="let condition of matchedRuleInfo.Conditions"
												style="margin-left: 10px; margin-top: 4px"
											>
												� {{ formatCondition(condition) }}
											</div>
											<div
												*ngIf="matchedRuleInfo.TotalRequiredApprovals >= 0"
												style="margin-top: 8px; font-style: italic"
											>
												Required Approvals:
												{{
													matchedRuleInfo.TotalRequiredApprovals === -1 ? 'All' : matchedRuleInfo.TotalRequiredApprovals
												}}
											</div>
										</div>
									</span>
								</ng-container>
							</ng-container>
							{{ approver.name }}
							<span *ngIf="approver.isThresholdUser === true && approver.groupName"
								><strong>(Threshold User)</strong></span
							>
							<span *ngIf="approver.isThresholdUser === false && approver.groupName">
								<strong>(Non-threshold User)</strong></span
							>
						</td>
						<td>
							<span *ngIf="approver.hasApproved">
								{{ approver.approvedBy }}
								<strong class="text-secondary" *ngIf="approver.userId != approver.approvedById && approver.approvedById"
									>(Skipped)</strong
								>
							</span>
						</td>
						<td>{{ approver.workflowStep }}</td>
						<td *ngIf="!hideCurrentApproveColumn">{{ isNextApprover(approver) ? 'Yes' : 'No' }}</td>
						<td>{{ approver.oldUserName }}</td>
						<td>{{ approver.approvedDate | date : 'short' }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>
